var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _rect2, _rect3, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _ellipse2, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFullPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 114,
    viewBox: "0 0 176 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6970_149962",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 68,
    height: 94
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.38219,
    y: 11.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    fill: "white",
    stroke: "#142030",
    strokeWidth: 1.47
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6970_149962)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.32031,
    y: 12.0566,
    width: 69.4819,
    height: 90,
    rx: 5.13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.2272,
    y: 62.6881,
    width: 28.3746,
    height: 10.6544,
    rx: 4.395,
    fill: "#86a3b3",
    stroke: "#142030",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5163,
    y: 90.6647,
    width: 17.1828,
    height: 3.19321,
    rx: 1.59661,
    fill: "#86a3b3",
    stroke: "#142030",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0764 85.3114H31.5295C32.7954 85.3114 33.8251 84.2416 33.8251 82.9275V70.4015C33.8251 69.0873 32.7952 68.0176 31.5295 68.0176H17.0764C15.8111 68.0176 14.7812 69.0873 14.7812 70.4015V82.9275C14.7812 84.2416 15.8111 85.3114 17.0764 85.3114ZM28.464 84.0659H20.1425V83.2164C20.1425 81.6856 20.9184 80.3472 22.0773 79.5795C22.7322 79.9993 23.4924 80.2446 24.3058 80.2446C25.1175 80.2446 25.876 79.9998 26.5298 79.5808C27.6882 80.3486 28.464 81.6862 28.464 83.2165V84.0659ZM21.0945 75.4435C21.0945 73.4793 22.5353 71.8817 24.3058 71.8817C26.0734 71.8817 27.5119 73.4793 27.5119 75.4435C27.5119 77.4041 26.0734 78.9991 24.3058 78.9991C22.5354 78.9991 21.0945 77.404 21.0945 75.4435ZM15.9803 70.4015C15.9803 69.7738 16.4721 69.263 17.0764 69.263H31.5295C32.1342 69.263 32.6262 69.7738 32.6262 70.4015V82.9275C32.6262 83.5551 32.1344 84.0659 31.5295 84.0659H29.6629V83.2164C29.6629 81.3873 28.8021 79.771 27.4868 78.7557C28.2432 77.8933 28.711 76.7277 28.711 75.4433C28.711 72.7926 26.735 70.6361 24.3058 70.6361C21.8737 70.6361 19.8954 72.7925 19.8954 75.4433C19.8954 76.7261 20.3627 77.8901 21.1181 78.7522C19.8019 79.767 18.9434 81.3867 18.9434 83.2164V84.0659H17.0764C16.4721 84.0659 15.9803 83.5551 15.9803 82.9275V70.4015Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9084 79.2266H42.3355C41.8952 79.2266 41.5391 79.5675 41.5391 79.9886C41.5391 80.4099 41.8953 80.7506 42.3355 80.7506H63.9084C64.3487 80.7506 64.7048 80.4097 64.7048 79.9886C64.7048 79.5675 64.3487 79.2266 63.9084 79.2266Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9084 82.8848H42.3355C41.8952 82.8848 41.5391 83.2257 41.5391 83.6468C41.5391 84.0681 41.8953 84.4088 42.3355 84.4088H63.9084C64.3487 84.4088 64.7048 84.0679 64.7048 83.6468C64.7048 83.2257 64.3487 82.8848 63.9084 82.8848Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4361 88.9805H42.0713C41.7771 88.9805 41.5391 89.3214 41.5391 89.7425C41.5391 90.1638 41.7772 90.5045 42.0713 90.5045H66.4361C66.7304 90.5045 66.9684 90.1636 66.9684 89.7425C66.9684 89.3212 66.7304 88.9805 66.4361 88.9805Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4361 95.0762H42.0713C41.7771 95.0762 41.5391 95.4171 41.5391 95.8382C41.5391 96.2595 41.7772 96.6002 42.0713 96.6002H66.4361C66.7304 96.6002 66.9684 96.2593 66.9684 95.8382C66.9684 95.4169 66.7304 95.0762 66.4361 95.0762Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3482 100.541C57.7276 99.8894 58.107 99.2383 58.3024 99.2713C58.4978 99.3042 58.4978 100.041 58.6077 100.095C58.7175 100.149 58.9371 99.4979 59.0503 99.4281C59.1634 99.3582 59.1634 99.8894 59.1634 100.129C59.1634 100.3 59.5229 99.6121 60.1174 98.9174C60.2665 98.7431 60.4523 99.3193 60.5237 99.5408C60.5951 99.7622 60.635 99.7108 61.025 98.9904C61.415 98.2699 62.1538 96.882 62.6142 95.9614C63.0747 95.0408 63.2345 94.6295 63.3467 94.3748C63.4589 94.1201 63.5188 94.0345 63.2302 95.4725C62.9416 96.9105 62.3026 99.8749 61.7838 101.753C61.2649 103.632 60.8855 104.334 60.6202 104.756C60.3548 105.178 60.2151 105.298 60.0233 105.188C59.4563 104.864 59.2451 104.092 59.0539 103.428C58.9474 103.058 58.8827 102.609 58.8415 102.106C58.8004 101.602 58.8004 101.054 58.9501 100.488C59.2588 99.3235 59.8877 98.7066 60.2099 98.6113C60.3478 98.5705 60.4523 98.6017 60.5337 98.739C60.9759 99.4853 60.3149 99.9689 60.3322 100.09C60.3581 100.271 61.1082 100.245 60.4281 100.297C59.7479 100.35 57.7911 100.367 55.9943 100.316C54.1975 100.265 52.62 100.145 51.9072 100.057C51.1944 99.9699 51.3941 99.9185 53.6036 99.8492C55.8131 99.7799 60.0263 99.6942 63.2051 99.4958C66.3839 99.2975 68.4007 98.9891 70.5391 98.6713",
    stroke: "#142030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.38219,
    y: 11.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    stroke: "#142030",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1172,
    y: 12.0566,
    width: 63.886,
    height: 43.8342,
    rx: 5.13,
    fill: "#C2CDD9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64844 55.8906H74.2339",
    stroke: "#142030",
    strokeWidth: 1.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.805 41.9025C41.815 41.9025 41.8247 41.9047 41.8347 41.9047C41.8447 41.9047 41.8525 41.9029 41.8616 41.9028C43.8347 41.8936 45.724 41.1037 47.116 39.7058C48.508 38.308 49.2895 36.4159 49.2895 34.4436C49.2895 32.4712 48.508 30.5792 47.116 29.1813C45.724 27.7834 43.8347 26.9935 41.8616 26.9843C41.8525 26.9843 41.8437 26.9824 41.8347 26.9824C41.8257 26.9824 41.815 26.9843 41.805 26.9845C39.8301 26.991 37.9383 27.7797 36.5442 29.1778C35.15 30.576 34.3672 32.4695 34.3672 34.4435C34.3672 36.4176 35.15 38.3111 36.5442 39.7092C37.9383 41.1074 39.8301 41.8961 41.805 41.9025ZM36.0363 36.6783C36.7302 37.0703 37.6187 37.3889 38.6708 37.606C38.8877 38.6568 39.2061 39.5444 39.5979 40.2379C38.7895 39.9243 38.0553 39.4458 37.4421 38.833C36.8289 38.2201 36.3502 37.4863 36.0363 36.6783ZM38.4624 36.2838C36.5893 35.8178 35.6146 35.0427 35.6146 34.4437C35.6146 33.8447 36.5893 33.07 38.4624 32.6032C38.3283 33.8264 38.3283 35.0606 38.4624 36.2838ZM41.8353 28.2266H41.8386C42.4377 28.2307 43.2104 29.2043 43.6756 31.0727C42.4519 30.9384 41.2172 30.9384 39.9935 31.0727C40.4589 29.2045 41.2313 28.2313 41.8303 28.2266C41.832 28.2268 41.8337 28.2266 41.8353 28.2266ZM39.7471 32.3567C41.1324 32.1685 42.5367 32.1685 43.922 32.3567C44.1107 33.7413 44.1107 35.1451 43.922 36.5298C42.5367 36.7179 41.1324 36.7179 39.7471 36.5298C39.5589 35.1451 39.5589 33.7414 39.7471 32.3567ZM39.9935 37.814C41.2172 37.9481 42.4519 37.9481 43.6756 37.814C43.2106 39.6826 42.4377 40.6559 41.8386 40.6601H41.8353C41.8337 40.6601 41.832 40.6601 41.8303 40.6601C41.2313 40.6556 40.4586 39.6824 39.9935 37.8145V37.814ZM44.0713 40.2379C44.4631 39.5443 44.7814 38.6567 44.9983 37.6057C46.0503 37.3887 46.9386 37.0702 47.6325 36.6783C47.3188 37.4863 46.8401 38.2202 46.227 38.8331C45.6138 39.446 44.8797 39.9246 44.0713 40.2382L44.0713 40.2379ZM45.2067 32.6029C47.0801 33.0693 48.0548 33.8441 48.0548 34.4434C48.0548 35.0427 47.0801 35.8175 45.2067 36.2835C45.3412 35.0603 45.3412 33.8261 45.2067 32.6029ZM47.6326 32.2081C46.9386 31.8163 46.0503 31.4978 44.9983 31.2808C44.7814 30.2298 44.4631 29.3421 44.0713 28.6486C44.8796 28.9622 45.6138 29.4407 46.227 30.0536C46.8401 30.6665 47.3188 31.4004 47.6326 32.2085V32.2081ZM39.5975 28.6492C39.2058 29.3427 38.8875 30.2302 38.6705 31.2811C37.6184 31.4982 36.7302 31.8168 36.036 32.2089C36.3498 31.4009 36.8286 30.6671 37.4418 30.0542C38.055 29.4414 38.7891 28.9629 39.5975 28.6492Z",
    fill: "#142030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64844 98.4047V107.811C1.64844 110.645 3.94639 112.943 6.78105 112.943H15.6671",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 98.4047V107.811C81.5 110.645 79.202 112.943 76.3674 112.943H67.4813",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64844 15.5953V6.18926C1.64844 3.35459 3.94639 1.05664 6.78105 1.05664H15.6671",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 15.5953V6.18926C81.5 3.35459 79.202 1.05664 76.3674 1.05664H67.4813",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.1331,
    cy: 11.8284,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9688 4.12695C68.3556 4.12695 66.7787 4.58881 65.4374 5.45413C64.0961 6.31945 63.0507 7.54935 62.4334 8.98832C61.816 10.4273 61.6545 12.0107 61.9692 13.5383C62.2839 15.0659 63.0607 16.4691 64.2014 17.5704C65.3421 18.6718 66.7954 19.4218 68.3775 19.7256C69.9597 20.0295 71.5997 19.8735 73.09 19.2775C74.5804 18.6815 75.8542 17.6721 76.7504 16.3771C77.6466 15.082 78.125 13.5595 78.125 12.002C78.125 9.91337 77.2657 7.91034 75.7361 6.43349C74.2065 4.95664 72.1319 4.12695 69.9688 4.12695ZM68.8036 15.1468L65.8906 12.3343L66.8173 11.4395L68.8036 13.3571L73.1206 9.18945L74.0502 10.0815L68.8036 15.1468Z",
    fill: "#00D492"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6970_149962",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 12,
    width: 65,
    height: 91
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102.969,
    y: 12.0566,
    width: 63.886,
    height: 90,
    rx: 5.13,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6970_149962)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6970_149962",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: -7,
    width: 96,
    height: 109
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.672,
    y: -7.8172,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    transform: "rotate(23.868 108.672 -7.8172)",
    fill: "white",
    stroke: "#142030",
    strokeWidth: 1.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6970_149962)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.484,
    y: -7.98047,
    width: 69.4819,
    height: 90,
    rx: 5.13,
    transform: "rotate(23.868 106.484 -7.98047)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.093,
    y: 51.6395,
    width: 28.3746,
    height: 10.6544,
    rx: 4.395,
    transform: "rotate(23.868 116.093 51.6395)",
    fill: "#86a3b3",
    stroke: "#142030",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7653 62.9564L98.9824 68.8046C100.14 69.3168 101.515 68.7552 102.046 67.5534L107.115 56.0986C107.646 54.8969 107.137 53.5019 105.98 52.9898L92.7629 47.1416C91.6059 46.6296 90.2312 47.1911 89.6995 48.3929L84.6311 59.8477C84.0993 61.0495 84.6083 62.4444 85.7653 62.9564ZM96.683 66.4252L89.0732 63.0581L89.4169 62.2812C90.0363 60.8814 91.2874 59.9714 92.6579 59.7383C93.0869 60.3872 93.6828 60.919 94.4267 61.2481C95.1689 61.5766 95.9616 61.6597 96.729 61.541C97.4777 62.712 97.6459 64.2491 97.0267 65.6484L96.683 66.4252ZM93.4327 55.5582C94.2274 53.762 96.1915 52.8841 97.8105 53.6005C99.427 54.3157 100.096 56.3587 99.3012 58.1549C98.5079 59.9479 96.547 60.8244 94.9306 60.1092C93.3116 59.3929 92.6394 57.3511 93.4327 55.5582ZM90.796 48.8781C91.05 48.3041 91.7064 48.036 92.259 48.2805L105.476 54.1287C106.029 54.3734 106.272 55.0396 106.018 55.6135L100.95 67.0683C100.696 67.6423 100.039 67.9104 99.4863 67.6656L97.7794 66.9104L98.1232 66.1335C98.8633 64.4608 98.7301 62.6345 97.938 61.1737C98.9787 60.6911 99.8781 59.8145 100.398 58.64C101.47 56.2159 100.536 53.4443 98.3145 52.4614C96.0904 51.4773 93.4088 52.6488 92.3362 55.0729C91.8171 56.246 91.7735 57.4995 92.1155 58.5936C90.5012 58.989 89.0608 60.1228 88.3204 61.796L87.9766 62.5729L86.2693 61.8175C85.7167 61.573 85.4736 60.9068 85.7276 60.3329L90.796 48.8781Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.058 76.3443L111.33 67.6152C110.927 67.4371 110.464 67.6047 110.293 67.9898C110.123 68.3751 110.311 68.8309 110.713 69.0089L130.441 77.738C130.844 77.9162 131.307 77.7485 131.478 77.3634C131.648 76.9783 131.461 76.5225 131.058 76.3443Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.581 79.69L109.853 70.9609C109.451 70.7828 108.987 70.9504 108.817 71.3355C108.646 71.7208 108.834 72.1766 109.237 72.3546L128.965 81.0837C129.367 81.2619 129.831 81.0942 130.001 80.7091C130.172 80.324 129.984 79.8682 129.581 79.69Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.424 86.287L107.143 76.4283C106.874 76.3092 106.518 76.5246 106.348 76.9098C106.177 77.295 106.257 77.703 106.526 77.822L128.807 87.6807C129.077 87.7998 129.432 87.5844 129.603 87.1993C129.773 86.814 129.693 86.4061 129.424 86.287Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.955 91.8612L104.674 82.0025C104.405 81.8834 104.05 82.0989 103.879 82.484C103.709 82.8692 103.789 83.2772 104.058 83.3962L126.339 93.255C126.608 93.374 126.963 93.1586 127.134 92.7735C127.304 92.3882 127.224 91.9803 126.955 91.8612Z",
    fill: "#142030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.437 93.1812C117.048 92.7393 117.658 92.2973 117.823 92.4066C117.989 92.5158 117.691 93.1896 117.769 93.2834C117.848 93.3772 118.312 92.8707 118.444 92.8526C118.576 92.8345 118.361 93.3203 118.264 93.5392C118.195 93.6954 118.802 93.2121 119.626 92.8174C119.833 92.7183 119.77 93.3204 119.746 93.5518C119.721 93.7832 119.779 93.7524 120.427 93.2513C121.075 92.7503 122.312 91.78 123.106 91.1244C123.899 90.4689 124.212 90.1575 124.418 89.97C124.623 89.7825 124.713 89.7284 123.867 90.9266C123.021 92.1249 121.237 94.5772 120.003 96.085C118.768 97.5927 118.137 98.0817 117.724 98.3601C117.31 98.6385 117.134 98.6917 117.003 98.5139C116.615 97.9883 116.735 97.1962 116.829 96.5115C116.881 96.1302 117.003 95.6939 117.17 95.2166C117.336 94.7394 117.558 94.2379 117.923 93.7817C118.677 92.8414 119.502 92.5317 119.835 92.5749C119.977 92.5934 120.06 92.6642 120.079 92.8227C120.182 93.6841 119.382 93.8588 119.348 93.9762C119.299 94.1525 119.995 94.432 119.352 94.205C118.709 93.978 116.912 93.2018 115.29 92.428C113.667 91.6542 112.273 90.9062 111.657 90.5378C111.041 90.1694 111.244 90.2032 113.293 91.0338C115.341 91.8644 119.229 93.4909 122.216 94.5957C125.203 95.7006 127.172 96.2346 129.256 96.8092",
    stroke: "#142030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.672,
    y: -7.8172,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    transform: "rotate(23.868 108.672 -7.8172)",
    stroke: "#142030",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.047,
    y: -6.84766,
    width: 63.886,
    height: 43.8342,
    rx: 5.13,
    transform: "rotate(23.868 109.047 -6.84766)",
    fill: "#C2CDD9"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8828 33.0488L149.945 59.1821",
    stroke: "#142030",
    strokeWidth: 1.47
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.944 33.265C125.953 33.2691 125.961 33.275 125.971 33.2791C125.98 33.2831 125.988 33.2846 125.996 33.2882C127.804 34.0782 129.851 34.1203 131.69 33.4052C133.529 32.6901 135.009 31.2761 135.807 29.4724C136.605 27.6687 136.656 25.6223 135.948 23.7807C135.241 21.9391 133.833 20.4523 132.032 19.6456C132.024 19.6419 132.017 19.6366 132.009 19.6329C132 19.6293 131.99 19.6267 131.981 19.6228C130.172 18.8296 128.123 18.7854 126.282 19.4999C124.442 20.2143 122.959 21.6291 122.161 23.4344C121.362 25.2396 121.312 27.2879 122.021 29.1306C122.73 30.9733 124.141 32.46 125.944 33.265ZM122.783 26.1534C123.259 26.7927 123.942 27.4435 124.817 28.0677C124.59 29.1165 124.522 30.057 124.599 30.8497C123.987 30.2358 123.509 29.5012 123.197 28.6926C122.884 27.8841 122.743 27.0193 122.783 26.1534ZM125.161 26.7743C123.637 25.5902 123.059 24.487 123.301 23.9393C123.544 23.3915 124.749 23.0774 126.65 23.4085C126.033 24.4728 125.533 25.6015 125.161 26.7743ZM131.506 20.7709L131.509 20.7723C132.055 21.0184 132.368 22.2214 132.037 24.1182C130.972 23.5003 129.843 23.0007 128.67 22.6283C129.851 21.1082 130.951 20.5308 131.501 20.769C131.503 20.7698 131.504 20.7702 131.506 20.7709ZM127.925 23.7029C129.268 24.0913 130.552 24.6595 131.743 25.3922C131.355 26.7347 130.787 28.0185 130.054 29.2083C128.711 28.8199 127.427 28.2517 126.236 27.5191C126.625 26.1767 127.193 24.893 127.925 23.7029ZM125.942 28.7931C127.007 29.411 128.136 29.9106 129.309 30.283C128.128 31.8037 127.027 32.381 126.478 32.1425L126.475 32.1411C126.473 32.1404 126.472 32.1398 126.47 32.1391C125.924 31.8926 125.611 30.69 125.942 28.7936L125.942 28.7931ZM128.69 32.6598C129.329 32.1841 129.98 31.5011 130.603 30.6278C131.653 30.855 132.594 30.9232 133.387 30.8455C132.773 31.4575 132.039 31.935 131.23 32.2474C130.421 32.5598 129.556 32.7003 128.69 32.6601L128.69 32.6598ZM132.818 26.1372C134.343 27.3217 134.92 28.4246 134.678 28.9727C134.435 29.5207 133.231 29.8348 131.329 29.503C131.947 28.4388 132.446 27.3102 132.818 26.1372ZM135.196 26.7577C134.72 26.1186 134.037 25.4679 133.162 24.8438C133.389 23.7949 133.457 22.8543 133.38 22.0616C133.992 22.6755 134.47 23.4101 134.783 24.2187C135.095 25.0273 135.236 25.8921 135.196 26.758L135.196 26.7577ZM129.288 20.2519C128.649 20.7276 127.999 21.4104 127.376 22.2837C126.326 22.0565 125.385 21.9884 124.591 22.066C125.205 21.4542 125.94 20.9768 126.748 20.6645C127.557 20.3522 128.422 20.2117 129.288 20.2519Z",
    fill: "#142030"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 98.4047V107.811C94.5 110.645 96.798 112.943 99.6326 112.943H108.519",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M174.352 98.4047V107.811C174.352 110.645 172.054 112.943 169.219 112.943H160.333",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 15.5953V6.18926C94.5 3.35459 96.798 1.05664 99.6326 1.05664H108.519",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.352 15.5953V6.18926C174.352 3.35459 172.054 1.05664 169.219 1.05664H160.333",
    stroke: "#142030",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.836,
    cy: 12.8323,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.672 5.12695C158.128 5.12695 154.516 8.61445 154.516 13.002C154.516 17.3895 158.128 20.877 162.672 20.877C167.216 20.877 170.828 17.3895 170.828 13.002C170.828 8.61445 167.216 5.12695 162.672 5.12695ZM165.818 16.9395L162.672 13.902L159.526 16.9395L158.594 16.0395L161.74 13.002L158.594 9.96445L159.526 9.06445L162.672 12.102L165.818 9.06445L166.75 9.96445L163.604 13.002L166.75 16.0395L165.818 16.9395Z",
    fill: "#FF6467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFullPage);
export default __webpack_public_path__ + "static/media/img-full-page.ecc0574a9d98fedaeb13a4fac8a1f4dd.svg";
export { ForwardRef as ReactComponent };